import { ColumnSizing } from '../tables-context';
import { MRT_ColumnDef } from 'material-react-table';
import { TableCell } from '../../../components/table/TableCell';
import { numberFormatter } from '../../../utils/utilities';
import React from 'react';
import { getTableDate } from '../disputes/disputes-data';
import { CopyComponent } from '../../../components/CopyComponent';
import { Link } from 'react-router-dom';
import { IFundsReserveDetails } from '../../order/order-interfaces';

export enum ReserveFundDetailsTableAccessorKeys {
	createdOn = 'createdOn',
	modifiedOn = 'modifiedOn',
	orderId = 'orderId',
	status = 'status',
	amount = 'amount',
	reason = 'reason',
	type = 'type',
	note = 'note',
}

export const defaultReserveFundDetailsColumnSizing: ColumnSizing = {
	[ReserveFundDetailsTableAccessorKeys.createdOn]: 100,
	[ReserveFundDetailsTableAccessorKeys.modifiedOn]: 100,
	[ReserveFundDetailsTableAccessorKeys.amount]: 100,
	[ReserveFundDetailsTableAccessorKeys.orderId]: 100,
	[ReserveFundDetailsTableAccessorKeys.status]: 100,
	[ReserveFundDetailsTableAccessorKeys.reason]: 100,
	[ReserveFundDetailsTableAccessorKeys.type]: 100,
	[ReserveFundDetailsTableAccessorKeys.note]: 100,
};

export const defaultReserveFundDetailsColumns: MRT_ColumnDef<IFundsReserveDetails>[] = [
	{
		accessorKey: ReserveFundDetailsTableAccessorKeys.createdOn,
		header: 'Created on',
		enableSorting: false,
		Header: <span className="text-muted fw-bolder main-font-family">Created on</span>,
		Cell: ({ renderedCellValue, table }: any): JSX.Element => (
			<TableCell
				additionalClass="main-font-family text-black fs-7"
				density={table?.options?.state?.density}
				isTextOverflow={false}
			>
				{getTableDate(renderedCellValue, true)}
			</TableCell>
		)
	},
	{
		accessorKey: ReserveFundDetailsTableAccessorKeys.modifiedOn,
		header: 'Modified on',
		enableSorting: false,
		Header: <span className="text-muted fw-bolder main-font-family">Modified on</span>,
		Cell: ({ renderedCellValue, table }: any): JSX.Element => (
			<TableCell
				additionalClass="main-font-family text-black fs-7"
				density={table?.options?.state?.density}
				isTextOverflow={false}
			>
				{getTableDate(renderedCellValue, true)}
			</TableCell>
		)
	},
	{
		accessorKey: ReserveFundDetailsTableAccessorKeys.orderId,
		header: 'Order id',
		enableSorting: false,
		Header: <span className="text-muted fw-bolder main-font-family">Order id</span>,
		Cell: ({ renderedCellValue, table }: any): JSX.Element => {
			const path = `/orders/${renderedCellValue}`;
			return (
				<TableCell
					additionalClass="d-flex align-items-center main-font-family text-black"
					density={table?.options?.state?.density}
					isTextOverflow={true}
				>
					<CopyComponent value={renderedCellValue} title="Order Id"/>
					<Link
						to={path}
						className="text-black fs-7 ms-2 fc-text-overflow"
					>
						<div className="fs-7 ms-2 fc-text-overflow">
							{renderedCellValue}
						</div>
					</Link>
				</TableCell>
			);
		}
	},
	{
		accessorKey: ReserveFundDetailsTableAccessorKeys.amount,
		header: 'Amount',
		enableSorting: false,
		Header: <span className="text-muted fw-bolder main-font-family">Amount</span>,
		Cell: ({ renderedCellValue, table }: any): JSX.Element => (
			<TableCell
				additionalClass="main-font-family text-black fs-7"
				density={table?.options?.state?.density}
				isTextOverflow={false}
			>
				{renderedCellValue
					? `$ ${numberFormatter(renderedCellValue / 100)}`
					: '-'
				}
			</TableCell>
		)
	},
	{
		accessorKey: ReserveFundDetailsTableAccessorKeys.status,
		header: 'Status',
		enableSorting: false,
		Header: <span className="text-muted fw-bolder main-font-family">Status</span>,
		Cell: ({ renderedCellValue, table }: any): JSX.Element => (
			<TableCell
				additionalClass="main-font-family text-black fs-7"
				density={table?.options?.state?.density}
				isTextOverflow={false}
			>
				{renderedCellValue ? renderedCellValue : '-'}
			</TableCell>
		)
	},
	{
		accessorKey: ReserveFundDetailsTableAccessorKeys.reason,
		header: 'Reason',
		enableSorting: false,
		Header: <span className="text-muted fw-bolder main-font-family">Reason</span>,
		Cell: ({ renderedCellValue, table }: any): JSX.Element => (
			<TableCell
				additionalClass="main-font-family text-black fs-7"
				density={table?.options?.state?.density}
				isTextOverflow={true}
			>
				{renderedCellValue ? renderedCellValue : '-'}
			</TableCell>
		)
	},
	{
		accessorKey: ReserveFundDetailsTableAccessorKeys.type,
		header: 'Type',
		enableSorting: false,
		Header: <span className="text-muted fw-bolder main-font-family">Type</span>,
		Cell: ({ renderedCellValue, table }: any): JSX.Element => (
			<TableCell
				additionalClass="main-font-family text-black fs-7"
				density={table?.options?.state?.density}
				isTextOverflow={false}
			>
				{renderedCellValue ? renderedCellValue : '-'}
			</TableCell>
		)
	},
	{
		accessorKey: ReserveFundDetailsTableAccessorKeys.note,
		header: 'Note',
		enableSorting: false,
		Header: <span className="text-muted fw-bolder main-font-family">Note</span>,
		Cell: ({ renderedCellValue, table }: any): JSX.Element => (
			<TableCell
				additionalClass="main-font-family text-black fs-7"
				density={table?.options?.state?.density}
				isTextOverflow={false}
			>
				{renderedCellValue ? renderedCellValue : '-'}
			</TableCell>
		)
	},
];